import { memo } from "react";

import type { Invoice } from "~/shared/schemas/invoice-schema.ts";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { InvoicePaymentCardMobile } from "../invoice-payment-card/invoice-payment-card-mobile.tsx";
import styles from "./selected-invoices-payment-mobile.module.css";

type SelectedInvoicesPaymentMobileProps = Readonly<{
	invoices: Invoice[];
	totalPayment: number;
	onAmountChange: (invoiceId: string, amount: number) => void;
	onDeleteInvoice: (invoiceId: string) => void;
}>;

export const SelectedInvoicesPaymentMobile =
	memo<SelectedInvoicesPaymentMobileProps>(
		({
			invoices,
			totalPayment,
			onAmountChange,
			onDeleteInvoice,
		}: SelectedInvoicesPaymentMobileProps) => {
			return (
				<div
					className={styles.selectedInvoicesPaymentMobile}
					data-testid={"selected-invoices-payment-mobile"}
				>
					{invoices.map((invoice) => (
						<InvoicePaymentCardMobile
							key={invoice.invoiceID}
							invoice={invoice}
							onAmountChange={onAmountChange}
							onDeleteInvoice={onDeleteInvoice}
						/>
					))}
					<div className={styles.totalPaymentSection}>
						<h4>Total Payment (USD)</h4>
						<h4>{formatCurrency(totalPayment)}</h4>
					</div>
				</div>
			);
		},
	);

SelectedInvoicesPaymentMobile.displayName = "SelectedInvoicesPaymentMobile";
